"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("@emotion/react");
const typings_1 = require("../typings");
const matchers_1 = require("./matchers");
const RichTextRenderer_styles_1 = require("./RichTextRenderer.styles");
/** A component for safely rendering rich-text content */
const RichTextRenderer = (_a) => {
    var { content, replacement = {}, className, id, tagName = 'span', styleReset, attributes = {}, matchers = [], disableDefaultMatchers = false, 'data-testid': dataTestId } = _a, rest = __rest(_a, ["content", "replacement", "className", "id", "tagName", "styleReset", "attributes", "matchers", "disableDefaultMatchers", 'data-testid']);
    const defaultMatchers = disableDefaultMatchers
        ? []
        : [
            new matchers_1.PhoneNumberMatcher('rtfPhoneNumber', {
                replacement: replacement[typings_1.MentionType.phone_number]
            }),
            new matchers_1.ProviderNameMatcher('rtfProviderName', {
                replacement: replacement[typings_1.MentionType.provider_name]
            }),
            new matchers_1.ProviderStateMatcher('rtfProviderState', {
                replacement: replacement[typings_1.MentionType.provider_state]
            })
        ];
    return (react_1.default.createElement(react_2.ClassNames, null, ({ cx }) => (react_1.default.createElement(RichTextRenderer_styles_1.StyledInterweaveRenderer, Object.assign({ tagName: tagName, styleReset: styleReset, className: styleReset ? cx(className, RichTextRenderer_styles_1.STYLE_RESET_CLASSNAME) : className, attributes: Object.assign(Object.assign(Object.assign({}, (id ? { id } : undefined)), (dataTestId ? { 'data-testid': dataTestId } : undefined)), attributes), content: content, matchers: [...defaultMatchers, ...matchers] }, rest)))));
};
exports.default = RichTextRenderer;
//# sourceMappingURL=RichTextRenderer.js.map